import { ax } from 'src/client'
import {
  START_ETP,
  START_ETR,
  STATUS_ETP,
  STATUS_ETR,
  STOP_ETP,
  STOP_ETR
} from './serviceURLS'

// ETR
export const getETRStatus = () => {
  return ax.get(STATUS_ETR)
}

export const startETR = () => {
  return ax.post(START_ETR)
}

export const stopETR = () => {
  return ax.post(STOP_ETR)
}

// ETP
export const getETPStatus = () => {
  return ax.get(STATUS_ETP)
}

export const startETP = () => {
  return ax.post(START_ETP)
}

export const stopETP = () => {
  return ax.post(STOP_ETP)
}
